import React from 'react'
import { FilterComponent } from '../../../types/types'
import Spoiler from '../../Spoiler/Spoiler'

const PriceFilter = (props: FilterComponent) => {
  const handlePrice = (from: number, to: number) => {
    let arrayToPush = props.products.filter(item => from <= item.price && item.price <= to)
    props.applyAction({name: (from.toString() + '-' + to.toString()),products: arrayToPush})
  }
  const prices = [[10,50],[50,100],[100,200],[200,500],[500,1000],[1000,10000]]
  return (
    <div>
      <Spoiler title="Price">
          <ul>
            {prices.map((item) => {
              return (
              <span key={item[0].toString()} onClick={() => handlePrice(item[0], item[1])} className="category-item">{'$' + item[0] + '- $' + item[1]}</span>)
            })}
          </ul>
        </Spoiler>
    </div>
  )
}

export default PriceFilter